import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import { type AnyAri } from '@atlassian/ari';
import { type SearchResultConversationPartial } from '@atlassian/dynamic-cards-search-client';

import { MessageBody } from '../../../../../../../common/ui/message-body';
import { SearchMetadata } from '../../../../../../../common/ui/search-metadata';
import { SearchResult } from '../../../../../../../common/ui/search-result';
import { usePrimaryProduct } from '../../../../../../../controllers/store';

import { i18n } from './messages';

interface ConversationSearchResultProps {
	partial: SearchResultConversationPartial;
	icon: React.ReactNode;
	cloudId?: string;
	position?: number;
	resultAri: AnyAri;
	integrationKey?: string;
}

export const ConversationSearchResult = ({
	partial,
	icon,
	position,
	integrationKey,
	cloudId,
}: ConversationSearchResultProps) => {
	const { formatMessage } = useIntl();
	const { entity, url } = partial;
	const [primaryProduct] = usePrimaryProduct();

	const memberCount = entity?.memberCount || entity?.members?.length;
	const parts: [string, React.ReactNode][] = [
		['label', <FormattedMessage {...i18n.label} />],
		[
			'memberCount',
			memberCount && <FormattedMessage {...i18n.memberCount} values={{ count: memberCount }} />,
		],
	];

	return (
		<SearchResult
			id={partial.id}
			description={<MessageBody partial={partial} />}
			icon={icon}
			headerMetadata={<SearchMetadata product={integrationKey} productSelected parts={parts} />}
			title={`#${entity?.displayName || formatMessage(i18n.unknownChannel)}`}
			url={url}
			isThirdParty
			cloudId={cloudId}
			primaryProduct={primaryProduct}
			position={position}
			partial={partial}
		/>
	);
};
